export const MSAL_CONFIG = {
    auth: {
        clientId: 'c24871a8-25ee-4280-a557-3f858b0f2683',
        authority: 'https://login.microsoftonline.com/72e4971c-a167-4f5a-9b74-9058084de321',
        redirectUri: `${process.env.MSAL_CALLBACK}`,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
};
//# sourceMappingURL=settings.js.map